import { render, staticRenderFns } from "./PowerBi.vue?vue&type=template&id=54f51fcb&scoped=true"
import script from "./PowerBi.vue?vue&type=script&lang=js"
export * from "./PowerBi.vue?vue&type=script&lang=js"
import style0 from "./PowerBi.vue?vue&type=style&index=0&id=54f51fcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f51fcb",
  null
  
)

export default component.exports